<template>
  <div class='no-email-service-content'>
    <a class="link-email-service-create"
       @click="modalOpen('edit-account');
        resetActiveAccount();" data-no-turbolink="true">
      <i class="icon-email-service icon-kp-mail-new"></i>
      <div class="email-service-create-text">{{ $t('account.actions.new') }}</div>
    </a>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: mapActions({
    modalOpen: 'modal/open',
    resetActiveAccount: 'account/resetActive',
  }),
};
</script>



// WEBPACK FOOTER //
// EmptyBoard.vue?887aa998